import { createFileRoute } from "@tanstack/react-router";
import { NodeGroupsPage } from "@/features/operator/NodeGroupsPage";

export const Route = createFileRoute("/app/operator/node-groups")({ component: NodeGroupsPage });
